export const FETCHING_COMBOS_DATA_REPORT_TXT = '@@toyota/FETCHING_COMBOS_DATA_REPORT_TXT';
export const FETCHED_COMBOS_DATA_REPORT_TXT = '@@toyota/FETCHED_COMBOS_DATA_REPORT_TXT';
export const FETCHED_COMBOS_DATA_REPORT_TXT_FAILED = '@@toyota/FETCHED_COMBOS_DATA_REPORT_TXT_FAILED';
